import React from "react";

export default function Tutorials() {
  return (
    <div>
      <h1>Tutoriais</h1>
    </div>
  );
}
